$shm_hitalama_map_touch_selection $mol_view
	point /number
	active false
	moving false
	attr *
		^
		active <= active
	sub /
		<= Ring $mol_svg
			attr *
				^
				viewBox \0 0 70 70
			style *
				^
				left <= point_x \0px
				top <= point_y \0px
			sub /
				<= Track $mol_svg_circle
					radius \29.9
					pos_x \35
					pos_y \35
				<= Progress $mol_svg_circle
					radius \29.9
					pos_x \35
					pos_y \35
		^ label_views /
			<= Label $mol_view
				style *
					^
					left <= label_left \0px
					top <= label_top \0px
				sub / \Обведите объекты
